import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { User } from '../../core/model/user.model';
import { TicketModel } from '../types/ticket.model';
import { AuthenticationSelectors } from "../../auth/state/authentication.selectors";
import { Subscription } from "rxjs/index";
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  templateUrl: 'support-form.component.html',
  selector: 'body-support',
  styleUrls: ['support-form.component.css']
})

export class SupportFormComponent implements OnInit, OnDestroy {

  ticket: TicketModel;
  fullLink: string;
  private delayTimeOut: NodeJS.Timeout;
  private baseUrl = 'https://autoremind.com/request-forms/support/support-ticket?reference='
  private subscription = new Subscription();

  constructor(private authenticationSelectors: AuthenticationSelectors,
              private clipboard: Clipboard) {
    this.ticket = new TicketModel();
    this.subscription.add(
      authenticationSelectors.selectCurrentUser().subscribe((user)=> {
        this.fullLink = this.baseUrl+user.userName;
        this.setDelayOpenLink(this.fullLink, 800);
      })
    )

  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
      clearTimeout(this.delayTimeOut);
    }

  ngOnInit(): void {}

  copyLinkToClipboard(): void{
    this.clipboard.copy(this.fullLink);
  }

  private setDelayOpenLink(linkUrl: string, delayInMillisecond: number){
    const openLinkUrl = ()=>{
      window.open(linkUrl, 'blank');
      window.focus();
    };
    if(this.delayTimeOut){
      clearTimeout(this.delayTimeOut);
    }
    this.delayTimeOut = setTimeout(openLinkUrl, delayInMillisecond);
  }
}
